export const headerBrandName = "F5gumd";
export const tenantLogoTooltip = "qnxxle";
export const shyHeaderAriaLabel = "i7WhP";
export const appLauncherButtonLabel = "Pup3Ue";
export default {headerBrandName,tenantLogoTooltip,shyHeaderAriaLabel,appLauncherButtonLabel};